import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M14.775 3.958h-8.75c-.92 0-1.666.747-1.666 1.667v8.75c0 .92.746 1.667 1.666 1.667h8.75c.92 0 1.667-.747 1.667-1.667v-8.75c0-.92-.746-1.667-1.667-1.667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="m7.692 8.958 2.083 1.875-2.083 1.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);